export default __webpack_public_path__ + "static/media/Group.84935855.svg";